var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 49,
    viewBox: "0 0 60 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8525 4.66504H24.667V0H35.4336V4.66504H41.1338V0H51.9004V14.6465H47.2783V37.6768C49.6207 36.3104 51.3726 34.9362 52.3789 33.6543C53.8605 31.7667 53.6437 30.1899 51.7617 29.1738C51.0621 28.7961 50.147 28.5044 49.0449 28.3008V25.3418C53.0027 25.361 56.0824 25.8956 57.958 26.9082C60.3757 28.2135 60.6544 30.2391 58.751 32.6641C56.8473 35.0889 52.8698 37.7758 47.4463 40.2998C42.0225 42.824 35.4615 45.0413 28.7998 46.6025C22.1381 48.1637 15.7546 48.9796 10.6582 48.9209C5.5617 48.8621 2.04168 47.9323 0.655251 46.2783C-0.731038 44.6243 0.0949509 42.3403 3.00193 39.7871C4.91533 38.1066 7.65848 36.3723 11.0146 34.7051V37.6533C10.2464 38.1711 9.56672 38.6886 8.98533 39.1992C6.7228 41.1864 6.08023 42.9636 7.15916 44.251C8.03377 45.2944 9.99888 45.9669 12.8242 46.209V14.6465H8.08592V0H18.8525V4.66504ZM29.998 20.5029C26.7574 20.5029 24.1301 23.1499 24.1299 26.415V45.4961C25.7346 45.2279 27.3888 44.8968 29.0654 44.5039C31.3716 43.9635 33.662 43.3212 35.8662 42.6025V26.415C35.8659 23.1499 33.2386 20.503 29.998 20.5029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastleLogo);
export default __webpack_public_path__ + "static/media/castle_logo.be38408daed7581b335d7eccce1e289e.svg";
export { ForwardRef as ReactComponent };